import { Button, Tooltip } from "antd"
import { useState } from "react"
import { ScheduledEvent, Visit } from "../scheduleApi"
import RemoveScheduledEventModal from "./Modals/RemoveScheduledEventModal"
import ScheduledEventsChangesModal, { ApplyChangesOption } from "./Modals/ScheduledEventsChangesModal"
import { Dayjs } from "dayjs"
import DeleteVisitModal from "../../visits/DeleteVisitModal"
import { useVisitHasTimeEntries } from "../../../domain/timeTracking/timeTrackingPeriodQueries"

type Props = {
  event: ScheduledEvent
  onRemove: (option: ApplyChangesOption, dateRange?: [Dayjs, Dayjs] | null) => void
  visitRemovedWithEvent: Visit | null
  onVisitRemoved: () => void
}

const RemoveButton = ({ event, onRemove, visitRemovedWithEvent, onVisitRemoved }: Props) => {
  const [removeEventModalOpen, setRemoveEventModalOpen] = useState(false)
  const [eventChangesModalOpen, setEventChangesModalOpen] = useState(false)
  const [deleteVisitModalOpen, setDeleteVisitModalOpen] = useState(false)
  const visitTimeEntriesQuery = useVisitHasTimeEntries(visitRemovedWithEvent?.id ?? '')
  const visitTimeEntriesFailed = !!visitRemovedWithEvent && visitTimeEntriesQuery.isError

  return (
    <>
      <div style={{ marginTop: '24px', display: 'flex', justifyContent: 'center' }}>
        <Tooltip title={visitTimeEntriesFailed ? "Couldn't check this visit's time entries. Close and reopen the drawer to try again." : undefined}>
          <Button
            type="text"
            loading={!!visitRemovedWithEvent && visitTimeEntriesQuery.isLoading}
            disabled={visitTimeEntriesFailed}
            style={{
              color: visitTimeEntriesFailed ? undefined : '#ff4d4f',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '500',
              fontSize: '20px',
              height: '40px',
            }}
            onClick={() => {
              if (visitRemovedWithEvent) {
                setDeleteVisitModalOpen(true)
              } else if (event.routeId !== null || event.repeatingId !== null) {
                setEventChangesModalOpen(true)
              } else {
                setRemoveEventModalOpen(true)
              }
            }}
          >
            {visitRemovedWithEvent ? 'Remove Visit' : 'Remove Event'}
          </Button>
        </Tooltip>
      </div>

      <RemoveScheduledEventModal
        open={removeEventModalOpen}
        onClose={() => setRemoveEventModalOpen(false)}
        onConfirm={() => {
          onRemove("this-event")
          setRemoveEventModalOpen(false)
        }}
        event={event}
      />
      <ScheduledEventsChangesModal
        open={eventChangesModalOpen}
        onClose={() => setEventChangesModalOpen(false)}
        onConfirm={(option, dateRange) => {
          onRemove(option, dateRange)
        }}
        event={event}
      />
      {visitRemovedWithEvent && <DeleteVisitModal
        visitId={visitRemovedWithEvent.id}
        isOpen={deleteVisitModalOpen}
        onClose={() => setDeleteVisitModalOpen(false)}
        onDeleted={onVisitRemoved}
      />}
    </>
  )
}

export default RemoveButton